var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remote_monitor_area no-drag"},[_c('video',{ref:"yourVideo",class:_vm.meetingStatusProps === 'on'? '' : 'hidden',staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"yourVideo"}}),_c('MeetingStatus',{attrs:{"meetingStatusProps":_vm.meetingStatusProps,"progressTimeProps":_vm.progressTimeProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }